import { render } from "./Group.vue?vue&type=template&id=45e435fc&scoped=true"
import script from "./Group.vue?vue&type=script&lang=js"
export * from "./Group.vue?vue&type=script&lang=js"

import "./Group.vue?vue&type=style&index=0&id=45e435fc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-45e435fc"

export default script